import { TSunTrigger, TTimeTrigger } from "../../automations/triggers/types";
import { ITimer } from "./types";
import { t } from "i18next";

export const timerToString = (timer: ITimer) => {
  return (
    t(timer.action.parameter as string) + " " + timerTriggerToString(timer)
  );
};

export const timerTriggerToString = (timer: ITimer) => {
  if (timer.trigger.type === "time") {
    const timeTrigger = timer.trigger as TTimeTrigger;
    return t("at WHAT", {
      what: timeTrigger.at + ", +/- " + timeTrigger.delta,
    });
  }
  if (timer.trigger.type === "sun") {
    const sunTrigger = timer.trigger as TSunTrigger;
    return t("at WHAT", {
      what: sunTrigger.event + ", " + sunTrigger.offset,
    });
  }
  return "";
};
